import { devAPI } from "../util/urls";

// get all organizations
export const getOrganizations = async (detail) => {
  try {
    let url = `${devAPI}/organizations`;
    if (detail) {
      url = `${devAPI}/organizations?detail=${detail}`;
    }

    const res = await fetch(url);

    if (!res.ok) {
      throw new Error(`Network response was not ok: ${res.statusText}`);
    }

    const parsed = await res.json();

    if (!parsed.organizations) {
      throw new Error(`API Error: No organizations found in response`);
    }

    return parsed.organizations;
  } catch (e) {
    console.error("Error:", e.message);
    return null;
  }
};

// get organization by id
export const getOrganization = async (id: string, detail?: string) => {
  try {
    let url = `${devAPI}/organizations/${id}`;
    if (detail) {
      url = `${devAPI}/organizations/${id}?detail=${detail}`;
    }

    let res = await fetch(url);
    const parsedRes = await res.json();

    if (!parsedRes) throw "failed to load orgs";

    return parsedRes.organization;
  } catch (e) {
    console.error(e);
    return null;
  }
};

// get organization admins
export const getOrganizationAdmins = async (listId: string) => {
  try {
    const res = await fetch(`${devAPI}/organizations/${listId}/admins`);
    let parsed = await res.json();
    return parsed.admins;
  } catch (err) {
    return err;
  }
};

// get organization survey results
export const getSurveyResultsByOrg = async (listId: string) => {
  try {
    const url = `${devAPI}/organizations/${listId}/surveys`;
    const res = await fetch(url);
    const data = await res.json();
    return data.surveys;
  } catch (e) {
    console.error(e);
    return null;
  }
};
